import React, { useState } from 'react';
import { register } from '../api/auth';

const FIELD_STYLE = {
  display: 'flex', flexDirection: 'column', gap: 4,
};
const LABEL_STYLE = {
  fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 2,
};
const REQUIRED_BADGE = (
  <span style={{ color: '#e53e3e', fontSize: 11, marginLeft: 4 }}>必須</span>
);
const OPTIONAL_BADGE = (
  <span style={{ color: '#aaa', fontSize: 11, marginLeft: 4 }}>任意</span>
);

const SECTION_LABEL = ({ children }) => (
  <div style={{
    fontSize: 11, fontWeight: 700, color: '#9B5FE3',
    borderBottom: '1px solid #e9d8fd', paddingBottom: 4, marginTop: 4, marginBottom: 2,
  }}>
    {children}
  </div>
);

export default function RegisterPage({ onBack }) {
  const [form, setForm] = useState({
    email: '',
    password: '',
    confirm: '',
    full_name: '',
    full_name_kana: '',
    phone: '',
    postal_code: '',
    address: '',
    company_name: '',
    company_name_kana: '',
  });
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [guardianConsent, setGuardianConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [done, setDone]       = useState(false);

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password, confirm, full_name, full_name_kana, phone, postal_code, address } = form;

    if (!email || !password) { setError('メールアドレスとパスワードを入力してください'); return; }
    if (password.length < 8) { setError('パスワードは8文字以上で設定してください'); return; }
    if (password !== confirm) { setError('パスワードが一致しません'); return; }
    if (!full_name)       { setError('氏名を入力してください'); return; }
    if (!full_name_kana)  { setError('氏名（フリガナ）を入力してください'); return; }
    if (!phone)           { setError('電話番号を入力してください'); return; }
    if (!postal_code)     { setError('郵便番号を入力してください'); return; }
    if (!address)         { setError('住所を入力してください'); return; }
    if (!termsAgreed)     { setError('利用規約・プライバシーポリシーへの同意が必要です'); return; }
    if (!guardianConsent) { setError('保護者からの同意取得済みであることのチェックが必要です'); return; }

    setLoading(true);
    setError('');
    try {
      await register({
        email,
        password,
        full_name,
        full_name_kana,
        phone,
        postal_code,
        address,
        company_name:      form.company_name      || undefined,
        company_name_kana: form.company_name_kana || undefined,
        terms_agreed:      true,
        guardian_consent:  true,
      });
      setDone(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        setError(detail.map(d => d.msg).join(' / '));
      } else {
        setError(detail ?? '登録に失敗しました');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
      height: '100%',
      background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
      padding: '40px 16px',
      overflowY: 'auto',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 24,
        padding: '40px 36px',
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        marginBottom: 40,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 44, lineHeight: 1, marginBottom: 8 }}>📸</div>
          <div style={{
            fontFamily: "'Nunito', 'M PLUS Rounded 1c', sans-serif",
            fontSize: 24, fontWeight: 900, color: '#7048D4',
          }}>
            えがおフォルダ
          </div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 5 }}>
            アカウントを作成
          </div>
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#333', marginBottom: 8 }}>
              確認メールを送信しました
            </div>
            <div style={{ fontSize: 13, color: '#666', lineHeight: 1.6, marginBottom: 24 }}>
              {form.email} 宛にメールをお送りしました。<br />
              メール内のリンクをクリックして登録を完了してください。
            </div>
            <button
              onClick={onBack}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#9B5FE3', fontSize: 13, textDecoration: 'underline',
              }}
            >
              ログインページへ戻る
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

            <SECTION_LABEL>ログイン情報</SECTION_LABEL>

            <div style={FIELD_STYLE}>
              <label style={LABEL_STYLE}>メールアドレス{REQUIRED_BADGE}</label>
              <input className="form-input" type="email" autoComplete="email"
                placeholder="example@email.com"
                value={form.email} onChange={set('email')} />
            </div>

            <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>パスワード（8文字以上）{REQUIRED_BADGE}</label>
                <input className="form-input" type="password" autoComplete="new-password"
                  placeholder="••••••••"
                  value={form.password} onChange={set('password')} />
              </div>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>パスワード（確認）{REQUIRED_BADGE}</label>
                <input className="form-input" type="password" autoComplete="new-password"
                  placeholder="••••••••"
                  value={form.confirm} onChange={set('confirm')} />
              </div>
            </div>

            <SECTION_LABEL>お客様情報</SECTION_LABEL>

            <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>氏名{REQUIRED_BADGE}</label>
                <input className="form-input" type="text" autoComplete="name"
                  placeholder="山田 太郎"
                  value={form.full_name} onChange={set('full_name')} />
              </div>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>氏名（フリガナ）{REQUIRED_BADGE}</label>
                <input className="form-input" type="text"
                  placeholder="ヤマダ タロウ"
                  value={form.full_name_kana} onChange={set('full_name_kana')} />
              </div>
            </div>

            <div style={FIELD_STYLE}>
              <label style={LABEL_STYLE}>電話番号{REQUIRED_BADGE}</label>
              <input className="form-input" type="tel" autoComplete="tel"
                placeholder="09012345678"
                value={form.phone} onChange={set('phone')} />
            </div>

            <div className="grid-2-label" style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: 10 }}>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>郵便番号{REQUIRED_BADGE}</label>
                <input className="form-input" type="text" autoComplete="postal-code"
                  placeholder="1234567"
                  value={form.postal_code} onChange={set('postal_code')} />
              </div>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>住所{REQUIRED_BADGE}</label>
                <input className="form-input" type="text" autoComplete="street-address"
                  placeholder="東京都渋谷区..."
                  value={form.address} onChange={set('address')} />
              </div>
            </div>

            <SECTION_LABEL>法人情報（任意）</SECTION_LABEL>

            <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>法人名{OPTIONAL_BADGE}</label>
                <input className="form-input" type="text" autoComplete="organization"
                  placeholder="株式会社〇〇"
                  value={form.company_name} onChange={set('company_name')} />
              </div>
              <div style={FIELD_STYLE}>
                <label style={LABEL_STYLE}>法人名（フリガナ）{OPTIONAL_BADGE}</label>
                <input className="form-input" type="text"
                  placeholder="カブシキガイシャ〇〇"
                  value={form.company_name_kana} onChange={set('company_name_kana')} />
              </div>
            </div>

            <SECTION_LABEL>同意事項</SECTION_LABEL>

            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, color: '#555', lineHeight: 1.5, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={termsAgreed}
                onChange={(e) => setTermsAgreed(e.target.checked)}
                style={{ marginTop: 3, flexShrink: 0 }}
              />
              <span>
                <a href="/terms" target="_blank" rel="noreferrer" style={{ color: '#9B5FE3' }}>利用規約</a>
                および
                <a href="/privacy" target="_blank" rel="noreferrer" style={{ color: '#9B5FE3' }}>プライバシーポリシー</a>
                に同意します
                <span style={{ color: '#e53e3e', fontSize: 11, marginLeft: 4 }}>必須</span>
              </span>
            </label>

            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, color: '#555', lineHeight: 1.5, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={guardianConsent}
                onChange={(e) => setGuardianConsent(e.target.checked)}
                style={{ marginTop: 3, flexShrink: 0 }}
              />
              <span>
                当園・当施設は、登録するすべての子供について、<strong>保護者（親権者）から
                顔写真の登録および AWS Rekognition による顔特徴量の解析・保存についての事前同意
                を取得済み</strong>です。また、新たに子供を登録する際は、その都度事前に保護者の
                同意を取得することに同意します
                <span style={{ color: '#e53e3e', fontSize: 11, marginLeft: 4 }}>必須</span>
              </span>
            </label>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{ width: '100%', padding: '12px', marginTop: 4 }}
            >
              {loading ? <><span className="spinner" />登録中…</> : 'アカウントを作成'}
            </button>

            {error && <div className="msg msg-error">{error}</div>}

            <button
              type="button"
              onClick={onBack}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#9B5FE3', fontSize: 13, textAlign: 'center',
                width: '100%', marginTop: 2, textDecoration: 'underline',
              }}
            >
              すでにアカウントをお持ちの方はこちら
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
